import UserPasswordChangeRequest, {
  UserPasswordChangeRequestBody,
} from "./user-password-change-request";

const createBody = (
  request: UserPasswordChangeRequest,
): UserPasswordChangeRequestBody => {
  return {
    newPassword: request.newPassword,
    oldPassword: request.oldPassword,
  };
};

const userPasswordChangeRequestFactory = {
  createBody,
};

export default userPasswordChangeRequestFactory;
